import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const DivideIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="6" r="2"></circle>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <circle cx="12" cy="18" r="2"></circle>
  </Icon>
);
